import { Link } from "react-router";
import { useT } from "@/i18n";

const NotFound = () => {
  const t = useT();
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center">
      <div className="text-center">
        <h1 className="text-muted-foreground text-9xl font-bold">404</h1>
        <h2 className="text-foreground mt-4 text-2xl font-semibold">{t("notFound.heading")}</h2>
        <p className="text-muted-foreground mt-2 mb-6 max-w-md">
          {t("notFound.body")}
        </p>
        <div className="flex gap-4">
          <Link
            to="/"
            className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-6 py-3 font-medium transition-colors"
          >
            {t("notFound.goHome")}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="bg-secondary text-secondary-foreground hover:bg-secondary/80 rounded-lg px-6 py-3 font-medium transition-colors"
          >
            {t("notFound.goBack")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
